// Assistant shell chrome: header brand, icon buttons, shell surfaces
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisShell = `
/* Header brand */
.pr-shell-header {
  height: 52px;
  padding: 0 10px 0 16px;
}
.pr-brand-dot {
  position: relative;
  width: 34px; height: 34px;
  background: var(--pr-ink);
  color: var(--pr-surface);
  display: grid; place-items: center;
  border-radius: var(--pr-r-md);
  overflow: hidden;
  font-family: var(--pr-font-serif);
  font-style: italic; font-weight: 500;
  font-size: 17px;
  letter-spacing: -0.01em;
  flex-shrink: 0;
}
.pr-brand-dot img { width: 100%; height: 100%; object-fit: cover; display: block; }
.pr-brand-name {
  font-family: var(--pr-font-serif);
  font-size: 17px; font-weight: 500;
  color: var(--pr-ink);
  letter-spacing: -0.01em;
  line-height: 1.15;
}
.pr-brand-sub {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 11.5px; color: var(--pr-ink-4);
  margin-top: 2px;
}
.pr-brand-sub-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--pr-success);
  box-shadow: 0 0 0 3px oklch(0.55 0.12 155 / 0.2);
}

/* Header iconbuttons */
.pr-iconbtn {
  width: 34px; height: 34px;
  border-radius: var(--pr-r-sm);
  background: transparent; border: none;
  color: var(--pr-ink-3);
  display: grid; place-items: center;
  cursor: pointer;
  transition: color 120ms ease, background 120ms ease;
  flex-shrink: 0;
}
.pr-iconbtn:hover { background: var(--pr-surface-2); color: var(--pr-ink); }
.pr-iconbtn.on { background: var(--pr-ink); color: var(--pr-surface); }
.pr-iconbtn svg { width: 18px; height: 18px; stroke-width: 1.7; }

/* Shell surfaces */
.pr-shell { background: var(--pr-surface); color: var(--pr-ink); }
.pr-shell-header {
  position: relative;
  z-index: 40;
  background: var(--pr-surface);
  border-bottom: 1px solid var(--pr-hairline);
}
.pr-panel-surface { background: var(--pr-bg); }
`;
